import shortId from "shortid";
import StudentService from "@/services/StudentService";
import SearchService from "@/services/SearchService";
import router from "@/router";

const uuidv4 = require("uuid/v4");

const getDefaultState = () => ({
  student: {
    uuid: "",
    first_name: "",
    middle_name: "",
    last_name: "",
    sex: "",
    emis_id: "",
    perivoli_id: "",
    languages: [],
    dob: null,
    country: "",
    region: "",
    district: "",
    village: "",
    address: "",
    user_flagged_duplicate: null,
    active: null,
  },
  students: [],
  schoolsTeachers: [],
  studentsExport: [],
});

const students = {
  namespaced: true,
  state: getDefaultState(),
  mutations: {
    first_name(state, val) {
      state.student.first_name = val;
    },
    middle_name(state, val) {
      state.student.middle_name = val;
    },
    last_name(state, val) {
      state.student.last_name = val;
    },
    active(state, val) {
      state.student.active = val;
    },
    dob(state, val) {
      state.student.dob = val;
    },
    sex(state, val) {
      state.student.sex = val;
    },
    emis_id(state, val) {
      state.student.emis_id = val;
    },
    languages(state, val) {
      state.student.languages = val;
    },
    country(state, val) {
      state.student.country = val;
    },
    region(state, val) {
      state.student.region = val;
    },
    district(state, val) {
      state.student.district = val;
    },
    village(state, val) {
      state.student.village = val;
    },
    address(state, val) {
      state.student.address = val;
    },
    user_flagged_duplicate(state, val) {
      state.student.user_flagged_duplicate = val;
    },
    student(state, val) {
      state.student = val;
    },
    students(state, val) {
      state.students = val;
    },
    studentsExport(state, val) {
      state.studentsExport = val;
    },
    schoolsTeachers(state, val) {
      state.schoolsTeachers = val;
    },
    resetStudents(state) {
      Object.assign(state, getDefaultState());
    },
  },
  actions: {
    async CREATE_STUDENT({ state }) {
      // fix the dob thang
      const key = await "dob";
      state.student.birthdate = await state.student[key];
      await delete state.student[key];

      if (state.student.birthdate === "") {
        state.student.birthdate = null;
      }
      state.student.uuid = uuidv4();
      await StudentService.addStudent(state.student);
    },
    async GET_STUDENTS(context) {
      let data;
      if (context.rootState.auth.user.admin) {
        const res = await StudentService.fetchStudents();
        data = res.data.students;
      }else if (context.rootState.auth.user.src) {
       
        const user_uuid = context.rootState.auth.user.uuid;
        const res = await StudentService.fetchStudents();
        data = res.data.students;
      } else if (context.rootState.auth.coordinator.uuid.length > 0) {
        console.log(
          "fetching coordinator students for:",
          context.rootState.auth.coordinator
        );
        const res = await StudentService.fetchCoordinatorStudents(
          context.rootState.auth.coordaintor.uuid
        );
        data = res.data.students;
      } else {
        console.log(
          "fetching trainer students for:",
          context.rootState.auth.trainer
        );
        const res = await StudentService.fetchTrainerStudents(
          context.rootState.auth.trainer.uuid
        );
        data = res.data.students;
      }
      context.commit("students", data);
    },
    async GET_STUDENTS_BY_SCHOOL(context) {
      const schoolId = await context.rootState.schools.selectedSchool;
      const res = await StudentService.fetchStudentsBySchool(schoolId);
      const data = await res.data.results;
      context.commit("students", data);
    },
    async GET_STUDENTS_EXPORT(context) {
      const res = await StudentService.fetchStudentsExport();
      const data = await res.data.students;
      context.commit("studentsExport", data);
    },
    async SEARCH_STUDENTS_LIST(context) {
      // const res = await SearchService.searchStudents(
      //   context.rootState.searches.name
      // );
      // const data = await res.data.results;
      // context.commit("students", data);

      let data;
      if (context.rootState.auth.user.admin) {
        const res = await SearchService.searchStudents(
          context.rootState.searches.name
        );
        data = res.data.results;
      }else if (context.rootState.auth.user.src) {
       
        const user_uuid = context.rootState.auth.user.uuid;
        const res = await SearchService.searchClusterStudents(
          user_uuid,
          context.rootState.searches.name
        );
        data = res.data.results;
      }  else if (context.rootState.auth.coordinator.uuid.length > 0) {
        console.log(
          "fetching coordinator students for:",
          context.rootState.auth.coordinator
        );
        const res = await SearchService.searchStudentsCoordinator(
          context.rootState.searches.name,
          context.rootState.auth.coordaintor.uuid
        );
        data = res.data.results;
      } else {
        console.log(
          "fetching trainer students for:",
          context.rootState.auth.trainer
        );
        const res = await SearchService.searchStudentsTrainer(
          context.rootState.searches.name,
          context.rootState.auth.trainer.uuid
        );
        data = res.data.results;
      }
      context.commit("students", data);
    },
    async GET_STUDENT(context) {
      const student = await StudentService.getStudent({
        id: router.currentRoute.params.id,
      });
      const data = student.data.student[0];
      context.commit("student", data);
    },
    async UPDATE_STUDENT({ state }) {
      await StudentService.updateStudent(state.student);
    },
    async GET_STUDENT_SCHOOL_TEACHER(context) {
      const res = await StudentService.fetchStudentSchoolAndTeacher({
        id: router.currentRoute.params.id,
      });
      const data = await res.data.results;
      context.commit("schoolsTeachers", data);
    },
    async RESET_STUDENTS_STATE(context) {
      await context.commit("resetStudents");
    },
  },
  getters: {
    getFirstName: (state) => state.student.first_name,
    getLastName: (state) => state.student.last_name,
    getCurrentSchool: (state) =>
      state.schoolsTeachers[0] ? state.schoolsTeachers[0].school_name : "",
    getCurrentSchoolId: (state) =>
      state.schoolsTeachers[0] ? state.schoolsTeachers[0].school_id : "",
    getCurrentTeacherId: (state) =>
      state.schoolsTeachers[0] ? state.schoolsTeachers[0].teacher_id : "",
    getCurrentTeacher: (state) =>
      state.schoolsTeachers[0]
        ? `${state.schoolsTeachers[0].first_name} ${state.schoolsTeachers[0].middle_name} ${state.schoolsTeachers[0].last_name}`
        : [],
  },
};

export default students;
